import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable()
export class CheckForUpdateService {

  constructor(private readonly appRef: ApplicationRef, private readonly updates: SwUpdate) {

  }
  init(): void {
    // Allow the app to stabilize first, before starting polling for updates with `interval()`.
    const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable));
    const everyOneMinute$ = interval(60000);
    const everyOneMinuteOnceAppIsStable$ = concat(appIsStable$, everyOneMinute$);

    everyOneMinuteOnceAppIsStable$.subscribe(() => this.updates.checkForUpdate());
  }
}
